import {mediaBase} from "./Repository";
import {i18n} from "@/main";
import key from "vue-rate-it/glyphs/key";

export function getProfileName(keyword) {
    if (keyword){
        const profileKey = `profileNames.${keyword}`;
        return i18n.t(profileKey);
    }else {
        return "";
    }
}

export function getProfileIcon(keyword) {

    switch (keyword) {
        case "SUPPLIER":
            return require('../assets/images/icons/supplier.png');
        case "PROCUREMENT":
            return require('../assets/images/icons/procurement.png');
        case "LOGISTIC":
            return require('../assets/images/icons/logistic.png');
        case "TRUCK":
            return require('../assets/images/icons/truck.png');
        default:
            return keyword;
    }

}

export const companyFormatListAZ = {
    'MMC': "MMC",
    'ASC': "ASC",
    'QSC': "QSC",
    'GOV_SERVICE': "Dövlət xidməti",
    'MINISTRY': "Nazirlik",
    'PUBLIC': "Publik Hüquqi Şəxs",
    'NGO': "QHT",
    'INDIVIDUAL': "(Fiziki şəxs)",
    'PERSONAL': "(Fərdi şəxs)",
    'AZ_REPRESENTATIVE': "Azərbaycan Respublikasında nümayəndəliyi",
    'EDU': "Elmi İstehsalat Mərkəzi",
    "IKF": "İstehsalat-Kommersiya Firması",
    "LABOR_UNION": "Həmkarlar İttifaqı",
    "PUBLIC_UNION": "İctimai Birliyi",
    "FIRM": "Firması",
};
export const companyFormatListEN = {
    "MMC": "LLC",
    "ASC": "OJSC",
    "QSC": "CJSC",
    "GOV_SERVICE": "Government Service",
    "MINISTRY": "Ministry",
    "PUBLIC": "Public Legal Entity",
    "NGO": "NGO",
    "INDIVIDUAL": "(Individual)",
    "PERSONAL": "(Personal)",
    "AZ_REPRESENTATIVE": "Representative in the Republic of Azerbaijan",
    "EDU": "Scientific Production Center",
    "IKF": "Production-Commercial Firm",
    "LABOR_UNION": "Labor Union",
    "PUBLIC_UNION": "Public Association",
    "FIRM": "Firm"
};
export const getErrorCode = (key)=>{
    return i18n.t(`userCompanyAdminDetails.${key}`)
}
export const companyFormatListRU = {
    "MMC": "ООО",
    "ASC": "АО",
    "QSC": "ЗАО",
    "GOV_SERVICE": "Государственная служба",
    "MINISTRY": "Министерство",
    "PUBLIC": "Публично-правовое лицо",
    "NGO": "НГО",
    "INDIVIDUAL": "(Физическое лицо)",
    "PERSONAL": "(Частное лицо)",
    "AZ_REPRESENTATIVE": "Представительство в Азербайджанской Республике",
    "EDU": "Научно-производственный центр",
    "IKF": "Производственно-коммерческая фирма",
    "LABOR_UNION": "Профсоюз",
    "PUBLIC_UNION": "Общественное объединение",
    "FIRM": "Фирма"
};

export function getCompanyFormat(format, locale) {
    let map;
    switch (locale) {
        case 'en':
            map = companyFormatListEN;
            break;
        case 'ru':
            map = companyFormatListRU;
            break;
        default:
            map = companyFormatListAZ;
    }

    if (map.hasOwnProperty(format)) {
        return map[format];
    }

    return format;

}

export function buildLongId(id, length) {

    return ("000000000000000000000000" + id).slice(0 - length);

}

export function getPhoto(path, size, defaultPhoto) {

    if (path) {
        return `${mediaBase}/${size}${path}`
    } else if (defaultPhoto) {
        return defaultPhoto
    }
    return require("../assets/images/dashboard/user.png")
}

export function getPhotos(pathString, size, defaultPhoto, maxPhotos = 6) {
    if (!pathString) {
        return [];
    }
    // Split the path string by commas
    const paths = pathString.split(',');

    // Limit to maxPhotos
    const limitedPaths = paths.slice(0, maxPhotos);

    // Map each path to a photo object with URL and filename
    return limitedPaths.map(path => {
        return {
            url: getPhoto(path, size, defaultPhoto),
            filename: path.split('/').pop()
        };
    });
}

export function getIsTaxIncluded(res) {
    if (res === 0) {
        return i18n.t("request.dvDaxil");
    } else if (res === 1) {
        return i18n.t("request.dvXaric");
    } else if (res === 2) {
        return i18n.t("request.sadldirilmiVergiDyicisi");
    } else {
        return '-';
    }
}

export function actionLocalization(action) {
    // Prefix for action translation keys
    const actionPrefix = "action.";

    // Construct the translation key using the action
    const translationKey = actionPrefix + action;

    // Use the translation key to fetch the translated text
    // Fallback to the original action text if no translation key is found
    return i18n.t(translationKey);
}


export const deliveryTypes = () => {
    return [
        {'key': 'auto', 'value': i18n.t("deliveryTypes.auto")},
        {'key': 'air', 'value': i18n.t("deliveryTypes.air")},
        {'key': 'marine', 'value': i18n.t("deliveryTypes.marine")},
        {'key': 'railway', 'value': i18n.t("deliveryTypes.railway")},
        {'key': 'small', 'value': i18n.t("deliveryTypes.small")},
        {'key': 'group', 'value': i18n.t("deliveryTypes.group")},
        {'key': 'multimodal', 'value': i18n.t("deliveryTypes.multimodal")},
        {'key': 'container', 'value': i18n.t("deliveryTypes.container")}
    ];
}

export function getDeliveryTypeName(key) {
    let v = key;

    // Call the deliveryTypes function to get the array
    const types = deliveryTypes();

    types.forEach((t) => {
        if (t.key === key) {
            v = t.value;
        }
    });

    return v;

}


export const loadTypes = () => {

    return [
        {'key': 'dangerous', 'value': i18n.t("loadTypes.dangerous"),},
        {'key': 'group', 'value': i18n.t("loadTypes.group"),},
        {'key': 'freeze', 'value': i18n.t("loadTypes.freeze"),},
        {'key': 'cool', 'value': i18n.t("loadTypes.cool"),},
        {'key': 'casuistic', 'value': i18n.t("loadTypes.casuistic"),},
        {'key': 'basic', 'value': i18n.t("loadTypes.basic"),}
    ]
}

export const truckTypes =()=> {
    return {
    "ref": {
        "name": i18n.t("truckTypes.ref.name"),
        "description": i18n.t("truckTypes.ref.description"),
    },
    "tent": {
        "name": i18n.t("truckTypes.tent.name"),
        "description":
            i18n.t("truckTypes.tent.description"),
    },
    "mega": {
        "name": i18n.t("truckTypes.mega.name"),
        "description": i18n.t("truckTypes.mega.description"),
    },
    "container": {
        "name": i18n.t("truckTypes.container.name"),
        "description": "",
    },
    "lowBed": {
        "name": i18n.t("truckTypes.lowBed.name"),
        "description": "",
    }
}}

export function getLoadTypeName(key) {

    let v = key;

    loadTypes.forEach((t) => {
        if (t.key === key) {
            v = t.value;
        }
    });

    return v;

}

export function getBrowserInfo() {

    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

// In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) !== -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
// In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
    }
// In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
    }
// In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) !== -1)
            fullVersion = nAgt.substring(verOffset + 8);
    }
// In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
    }
// In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) {
            browserName = navigator.appName;
        }
    }
// trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) !== -1)
        fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) !== -1)
        fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }
    var OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";


    return {
        OS: OSName,
        browserName: browserName,
        fullVersion: fullVersion,
        majorVersion: majorVersion,
        appName: navigator.appName,
        userAgent: navigator.userAgent
    };


}

export const requestName = (r) => {
    const requestTypeKey = r.requestType.toString();
    const profileTypeKey = r.profileType ? r.profileType.toString() : '';

    // Special key for the combined case of OFR and LOGISTIC
    const specialCaseKey = requestTypeKey === 'OFR' && profileTypeKey === 'LOGISTIC' ? 'OFR_LOGISTIC' : '';

    if (specialCaseKey) {
        // Use the special case key if it's defined
        return i18n.t(specialCaseKey);
    } else {
        return i18n.t(`requestNames.${requestTypeKey}`);
    }
}


export function getAzOrdinalSuffix(number) {
    // Convert to string to handle numbers like "1", "2", etc.
    const num = String(number);

    // Get the last digit
    const lastDigit = num.slice(-1);

    // Apply Azerbaijani ordinal suffix rules
    switch (lastDigit) {
        case '1':
        case '2':
        case '5':
        case '7':
        case '8':
            return '-ci';
        case '3':
        case '4':
            return '-cü';
        case '6':
            return '-cı';
        case '9':
        case '0':
            return '-cu';
        default:
            return '-ci'; // Default fallback
    }
}

export const showLimitExceedPopup = ($swal, message, errorCode, showResponseMessage = false) => {
    if (showResponseMessage) {

        $swal({
            title: `Funksiya məhdudlaşdırılmışdır`,
            html: `<p>${message}</p><br><button class="btn btn-primary" onclick="window.location.href='/dashboard/subscription'">Ödənişli paketi almaq üçün</button>`,
            icon: 'error'
        });
    } else if (errorCode === "you_have_used_all_chances") {

        $swal({
            title: `Limiti keçdiniz`,
            html: `<p>Siz paketinizdə bu funksiya üçün limitləri istifadə etmisiniz</p>
            <br><button class="btn btn-primary" onclick="window.location.href='/dashboard/subscription'">Paketi dəyişmək üçün</button>`,
            icon: 'error',
            showConfirmButton: false
        });

    } else if (errorCode === "action_not_allowed_on_package") {
        $swal({
            title: `Funksiya deaktivdir`,
            text: "Sizin paketinizdə bu funksiya mövcud deyil",
            icon: 'error'
        });

    } else {
        $swal({
            title: `${errorCode}`,
            text: `${message}`,
            icon: 'error'
        });

    }
}
